'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
const defaults = {
  img1200x630: null
};

class SocialScreenshots extends Immutable.Record(defaults) {
  constructor(json = {}) {
    super(cleanObject(json));
  }

}

export default SocialScreenshots;